import styled from "styled-components";
import { Text, Heading, List } from "../../../services/visualLibraryService";

export const SettingsPageStyled = styled.section`
  padding: ${props => props.theme.baseLayoutPaddingBs}%;
`;

export const TextDisclaimerStyled = styled(Text)`
  margin-top: ${props => props.theme.spacing.medium};
`;

export const BlockStyled = styled.div`
  & + & {
    width: 75%;
  }
`;

export const HeadingStyled = styled(Heading)`
  margin-bottom: ${props => props.theme.spacing.small};
`;

export const ListInfoStyled = styled(List)`
  position: absolute;
  bottom: ${props => props.theme.baseLayoutPaddingBs * 2}%;
`;

export const TextChannelsStyled = styled(Text)`
  margin-bottom: ${props => props.theme.spacing.xlarge};
`;
